import './resultPayment.css';
import { Box, Card, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { IInquiry } from '../IInquriry';
import CustomisedButton from '../../../../components/button/button';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import { changeRouteType, getpervInnerState } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { useMutation, useQueryClient } from 'react-query';
import { TotalInquiry } from '../../../../services/inquiry.service';
import { TotalInquiryRequest, IInquiryResponse } from '../../../../models/inquiry.model';
import { INQUIRY_REQUIRED_OTP, INQUIRY_RESULT } from '../../../../config/cacheKey';
import { v4 as uuid } from 'uuid';
import { ApiResultModel } from '../../../../models/common.model';
export default function ResultPayment({ setInnerState, setStep, referenceKey }: IInquiry) {
    const randomKeyForDispatch = Math.random();
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const queryClient = useQueryClient();
    useEffect(() => {
        setHeader('پرداخت', 'payment');
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: `inquiry ${randomKeyForDispatch}` }));
    }, [])
    const { mutateAsync: InquiryValidationOTPMutation, isLoading } = useMutation(TotalInquiry, {
        onSuccess: (data: ApiResultModel<IInquiryResponse>) => {
            if (data) {
                if (data.data.requiredOtpValidation) {
                    setInnerState!('otp');
                    queryClient.setQueryData(INQUIRY_REQUIRED_OTP, data.data.requiredOtpValidation);
                }
                else if (data.data.inquiries.length > 0) {
                    setInnerState!('inquiryResult')
                    queryClient.setQueryData(INQUIRY_RESULT, data.data.inquiries);
                }
                else {
                    setStep(uuid);
                }

            }
        },
        onError: () => { },
    });
    const handleContinue = () => {
        const request = {} as TotalInquiryRequest;
        request.referenceKey = referenceKey!;
        InquiryValidationOTPMutation(request);
    }
    return (
        <div>


            <Card className="!shadow-none cardContainer">
                <Grid container xs={12}>
                    <Grid
                        item
                        xs={12}
                        textAlign={'center'}
                        className="!pb-2 primaryColorLight-900 yekanBakhFaNum"
                    >
                        <div className="yekanBakhFaNum mt-2 primaryColorLight-900">
                            <span>8000000 ریال</span>
                        </div>
                        <div className="bgSecondaryColorLight badge mt-3">
                            <CheckCircleIcon />
                            &nbsp;پرداخت موفق
                        </div>
                        <div className="mt-5 mb-5 text-[var(--primary-text-color)]" style={{ fontSize: '.9em' }}>
                            لطفا جهت تکمیل فرآیند ثبت درخواست دکمه <span className='secondaryColorLight-600' >"ادامه"</span> را
                            بزنید
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <hr className="indented-hr" />
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        textAlign={'center'}
                        className="!pt-3 primaryColorLight-900 yekanBakhFaNum"
                    >
                        {[...Array(3)].map((_, index) => (
                            <Grid container xs={12} key={index} className="mt-5">
                                <Grid item xs={6} textAlign={'right'}>
                                    1200
                                </Grid>
                                <Grid item xs={6} textAlign={'left'}>
                                    12000
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Card>
            <Box className="button-container">
                <CustomisedButton
                    title="ثبت و ادامه"
                    disable={false}
                    onClick={handleContinue}
                    type="button"
                />
            </Box>
        </div>
    );
}
